import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../utils/cn.js";
export const Card = forwardRef(function Card({ as: Tag = "div", hoverable, className, children, ...rest }, ref) {
    return (_jsx(Tag, { ref: ref, "data-slot": "card", "data-hoverable": hoverable ? "true" : undefined, className: cn("rounded-sm border border-ink-200 bg-ivory shadow-1", hoverable && "transition-shadow duration-fast hover:shadow-2", className), ...rest, children: children }));
});
